import 'leaflet';
const version = '0.0.1';

class MapInstanceObjects{
    static init(element){
        var $element = $(element);
        if($element.data('map-instance')){
            return $element.data('map-instance');
        }else{
            let instance = new MapInstanceObjects(element)
            $element.data('map-instance', instance);
            return instance
        }
    }

    constructor(element) {
        this.$element = $(element);
        this.element = element;
        this.initMap();
    }

    initMap(){
        this.map = L.map('map', {
            scrollWheelZoom: false,
            zoomControl: false,
            fullscreenControl: true
        });
        this.renderer = L.canvas({ padding: 0.5 });
        L.control.zoom({
            position: 'topright'
        }).addTo(this.map);
        L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png").addTo(this.map);

        this.map.setView([55.1500, 23.9333], 8);


        this.loadAllBrandObjects(this.$element.data('type'));

        this.map.once('focus', function() {
            this.map.scrollWheelZoom.enable();
        }.bind(this));

        $('.m_location').click(function(e){
            e.preventDefault();
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                        var locationIcon = L.icon({
                            iconUrl: '/assets/images/map_icons/marker-icon.png',
                            iconSize: [25, 41],
                            iconAnchor: [12, 41],
                        });
                        this.map.setView([position.coords.latitude, position.coords.longitude], 8);
                        L.marker([position.coords.latitude, position.coords.longitude], {icon: locationIcon}).addTo(this.map);
                    }.bind(this),
                    function errorCallback(error) {
                        switch(error.code) {
                            case error.PERMISSION_DENIED:
                                alert("User denied the request for Geolocation.");
                                break;
                            case error.POSITION_UNAVAILABLE:
                                alert("Location information is unavailable.");
                                break;
                            case error.TIMEOUT:
                                alert("The request to get user location timed out.");
                                break;
                            case error.UNKNOWN_ERROR:
                                alert("An unknown error occurred.");
                                break;
                        }
                    });
            } else {
                alert("Geolocation is not supported by this browser.");
            }
        }.bind(this));
    }

    loadAllBrandObjects(id){
        $.get('/api/gis/objects_by_brand_type', {id: id}).done(function (result){
            if(result.geodata)
            {
                var type = result.types;
                var $types = [];
                var $typeMarker = [];
                var allTypesActive = true;
                type.forEach(function (element){
                    $typeMarker[element.id] = L.icon({
                        iconUrl: element.icon,
                        iconSize:     [20, 20], // size of the icon
                        iconAnchor:   [10, 10], // point of the icon which will correspond to marker's location
                    });
                    $types[element.id] = L.geoJson(result.geodata, {
                        renderer: this.rendererObject,
                        filter: function(feature, layer) {
                            return feature.properties.type == element.id;
                        },
                        pointToLayer: function (feature, latlng) {
                            return L.marker(latlng, {icon: $typeMarker[element.id]}
                            ).on('click', function() {
                                var that = this;
                                $.get('/gis/popupData', {
                                    id: feature.properties.id,
                                    type: 'Objects'
                                }).done(function (result){
                                    if (result) {
                                        that.bindPopup(result).openPopup();
                                    }
                                });
                            });
                        }
                    });
                    $types[element.id].addTo(this.map);
                    $('#objecttypes-' + element.id).click(function (e) {
                        e.preventDefault();
                        if(allTypesActive){
                            allTypesActive = false;
                            $('#map_filter a').addClass('opacity');
                            $types.forEach(function (item, index) {
                                this.map.removeLayer(item);
                            }.bind(this));
                        }
                        $('#objecttypes-' + element.id).toggleClass('opacity');

                        if (this.map.hasLayer($types[element.id])) {
                            this.map.removeLayer($types[element.id]);
                        } else {
                            this.map.addLayer($types[element.id])
                        }
                    }.bind(this));
                }.bind(this));
            }
        }.bind(this));
    }
}

export default MapInstanceObjects;